import './style.scss';

export function treatments_block() {
    const block = document.querySelector('.treatments_block');
    if (!block) return;
}

